import { useEffect, useState } from 'react';
import { collection, query, where, orderBy, getDocs } from 'firebase/firestore';
import { db } from '../firebase-config';
import { BlogPost } from '../types/blog-admin';
import { generateRssFeed } from '../utils/rss';
import { Loader2 } from 'lucide-react';

export default function RssPage() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchAndGenerateRss = async () => {
      try {
        // Fetch published posts
        const q = query(
          collection(db, 'blogPosts'),
          where('status', '==', 'published'),
          orderBy('publishedAt', 'desc')
        );
        const snapshot = await getDocs(q);
        const posts = snapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        })) as BlogPost[];

        // Generate RSS feed
        const baseUrl = window.location.origin;
        const rssXml = generateRssFeed(posts, baseUrl);

        // Set content type and render XML
        document.body.innerHTML = `<pre>${rssXml.replace(/</g, '&lt;').replace(/>/g, '&gt;')}</pre>`;

        // Create a downloadable version
        const blob = new Blob([rssXml], { type: 'application/rss+xml' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = 'rss.xml';
        document.body.appendChild(link);

        setLoading(false);
      } catch (error) {
        console.error('Error generating RSS feed:', error);
        document.body.innerHTML = '<h1>Error generating RSS feed</h1>';
        setLoading(false);
      }
    };

    fetchAndGenerateRss();
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
        <span className="ml-3 text-muted-foreground">Generating RSS feed...</span>
      </div>
    );
  }

  return null;
}
